import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import ResetPassEmail from './views/ResetPassEmail.vue';
import ResetPass from './views/ResetPass.vue';
import DraftStudents from './views/DraftStudents.vue';
import axios from 'axios';
import Register from './views/admin/Register.vue';

import AddCourse from './views/moderator/AddCourse.vue';
import AddStudent from './views/AddStudent.vue';
import SFEForm from './views/student/SFEForm.vue';
import StudentInvoice from './views/student/StudentInvoice.vue';
import AcceptApproval from './views/AcceptApproval.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/request-reset-pass',
      component: ResetPass,
    },
    {
      path: '/accept-approval',
      component: AcceptApproval,
    },
    {
      path: '/draft-students',
      component: DraftStudents,
    },
    {
      path: '/reset-pass',
      component: ResetPassEmail,
    },
    {
      path: '/register',
      component: Register,
    },
    {
      path: '/useful-info',
      name: 'useful-info',
      component: () => import('./views/UsefulInfo.vue'),
    },

    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile.vue'),
    },

    {
      path: '/admin/dashboard',
      name: 'admin',
      component: () => import('./views/admin/NewBoardAdmin.vue'),
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/admin/BoardAdmin.vue'),
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/CourseList.vue'),
    },
    {
      path: '/course/:id',
      alias: '/edit-course/:id',
      name: 'edit-course',
      component: AddCourse,
    },
    {
      path: '/add-course',
      name: 'add-course',
      component: AddCourse,
      props: true,
    },
    {
      path: '/add-student/:localId',
      props: true,
      name: 'local-student',
      component: AddStudent,
    },
    {
      path: '/quick-apply/:courseId',
      name: 'quick-apply',
      props: true,
      component: AddStudent,
    },
    {
      path: '/student/:id/:applicationId/:routeIsEdit',
      name: 'edit-student',
      props: true,
      meta: {
        showModal: true,
      },
      component: AddStudent,
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('./views/UnconList.vue'),
      children: [
        {
          path: '/form',
          name: 'sfe-form',
          props: true,
          meta: {
            showModal: true,
          },
          component: SFEForm,
        },
        {
          path: '/payment-form',
          name: 'payment-form',
          props: true,
          meta: {
            showModal: true,
          },
          component: StudentInvoice,
        },
      ],
    },
    {
      path: '/applications',
      name: 'applications',
      component: () => import('./views/ApplicationList.vue'),
      children: [
        {
          path: '/:id/:applicationId/:routeIsEdit',
          name: 'view-student',
          props: true,
          meta: {
            showModal: true,
          },
          component: AddStudent,
        },
      ],
    },
    {
      path: '/add-uni',
      name: 'add-uni',
      component: () => import('./views/moderator/AddUniversity.vue'),
    },
    {
      path: '/add-uni/:id',
      name: 'edit-uni',
      component: () => import('./views/moderator/AddUniversity.vue'),
    },
    {
      path: '/universities',
      name: 'universities',
      component: () => import('./views/UniversityList.vue'),
    },
    {
      path: '/view-team',
      name: 'view-team',
      component: () => import('./views/TeamList.vue'),
    },
    {
      path: '/excel-upload',
      name: 'excel-upload',
      component: () => import('./views/moderator/ExcelUpload.vue'),
    },
    {
      path: '/intakes',
      name: 'intakes',
      component: () => import('./views/moderator/Intakes.vue'),
    },
    {
      path: '/messaging',
      name: 'messaging',
      component: () => import('./views/messaging/Messaging.vue'),
    },
    {
      path: '/training',
      name: 'training',
      component: () => import('./views/helpers/InitialSetup.vue'),
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: () => import('./views/Leaderboard.vue'),
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('./views/Finance.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const adminPages = ['/register', '/users', '/finance', '/intakes'];
  const moderatorPages = ['/add-uni', 'add-course'];
  const unprotectedPaths = [
    '/reset-pass',
    '/request-reset-pass',
    '/login',
    '/accept-approval',
  ];
  const authRequiredAdmin = adminPages.includes(to.path);
  const authRequiredModerator = moderatorPages.includes(to.path);

  const loggedIn = localStorage.getItem('user');
  let user;
  let isAdmin = false;
  let isModerator = false;
  let showTutorial = true;

  if (loggedIn) {
    user = JSON.parse(loggedIn);
    isAdmin = user.roles.includes('ROLE_ADMIN');
    isModerator =
      user.roles.includes('ROLE_MODERATOR') ||
      user.roles.includes('ROLE_ADMIN');
    if (user.templateOptions) {
      showTutorial =
        'completedRegistration' in user.templateOptions
          ? !user.templateOptions.completedRegistration
          : true;
    } else {
      showTutorial = true;
    }
  }

  if (unprotectedPaths.includes(to.path)) {
    return next();
  } else if (!loggedIn) {
    return next({
      name: 'login',
    });
  } else if (showTutorial && to.path !== '/training') {
    return next({
      name: 'training',
    });
  } else if (
    (authRequiredModerator && !isModerator) ||
    (authRequiredAdmin && !isAdmin && loggedIn && to.name !== 'home')
  ) {
    axios.defaults.headers.common['x-access-token'] = user.accessToken;
    return next({
      name: 'home',
    });
  } else {
    axios.defaults.headers.common['x-access-token'] = user.accessToken;

    // gtag('config', window.GA_TRACKING_ID, {
    //     page_path: to.fullPath,
    //     app_name: 'Ask3.3 Web App',
    //     send_page_view: true,
    // });

    return next();
  }
});
